
























import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';

import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(PageModeMixin, EditMixin).extend({
	name: 'HlavniKarta',
	components: { ProvozovnaSelect },
});
